module.exports = require("redux-immutable");


//////////////////
// WEBPACK FOOTER
// external "redux-immutable"
// module id = 601
// module chunks = 0